// extracted by mini-css-extract-plugin
export default {"cls1":"Feed-cls1__b6f0b7be09e44bb6568c","cls2":"Feed-cls2___7c451b881a1cc1074a8 Feed-cls1__b6f0b7be09e44bb6568c"};